import React, { ComponentPropsWithoutRef } from 'react';
import { Link, makeStyles } from '@rbx/ui';

const useOperationTagStyles = makeStyles()((theme) => ({
  link: {
    color: theme.palette.content.standard,
  },
}));

const DLink: React.FC<ComponentPropsWithoutRef<typeof Link>> = ({ children, ...otherProps }) => {
  const {
    classes: { link },
  } = useOperationTagStyles();
  return (
    <Link className={link} {...otherProps}>
      {children}
    </Link>
  );
};

export default DLink;
